import { Component } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-teilnehmerliste-titel',
  templateUrl: './teilnehmerliste-titel.component.html',
  styleUrls: ['./teilnehmerliste-titel.component.scss']
})
export class TeilnehmerlisteTitelComponent {

  public titel = "Teilnehmerliste";

  constructor(public activeModal: NgbActiveModal) { }

  confirm() {
    this.activeModal.close(this.titel);
  }

  dismiss() {
    this.activeModal.dismiss();
  }
}
